export default {

    resetReviewsArray: (state) => {
        state.reviewsArray = []
    },

    addReviewsFromResponse: (state, array) => {
        state.reviewsArray = [...state.reviewsArray, ...array]
    },

    updateReviewsDataWithResponse: (state, response) => {
        state.responseReviewData = response
    },

    setLoading: (state, bool) => {
        state.loading = bool
    },

    setCurrentCard: (state, newVal) => {
        state.currentCard = newVal
    },

    setAnimating: (state, bool) => {
        state.animating = bool
    },

    setCardsDisplayed: (state, newVal) => {
        state.cardsDisplayed = newVal
    },

    setSliderCardWidth: (state, newVal) => {
        state.sliderCardWidth = newVal
    },

    setRatingsToShow: (state, newVal) => {
        state.ratingsToShow = newVal;
    },

    setViewDetailClicked: (state, bool) => {
        state.viewDetailClicked = bool;
    },

    setScreenType: (state, newType) => {
        state.screenType = newType
    },
}